import { useState } from 'react';
import { format, parseISO, isValid } from 'date-fns';
import { CalendarBlank } from '@phosphor-icons/react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

const DatePickerField = ({ value, onChange, minDate, maxDate, placeholder = 'Pick a date', testId }) => {
  const [open, setOpen] = useState(false);
  let dateObj = null;
  if (value) {
    const d = parseISO(value);
    if (isValid(d)) dateObj = d;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={`w-full flex items-center justify-between bg-gray-50 border border-gray-200 focus:bg-white focus:border-[#F97316] focus:ring-2 focus:ring-orange-100 rounded-xl px-4 py-2.5 text-sm outline-none transition-all ${dateObj ? 'text-gray-900' : 'text-gray-400'}`}
          data-testid={testId}
        >
          <span>{dateObj ? format(dateObj, 'MMM d, yyyy') : placeholder}</span>
          <CalendarBlank size={16} weight="bold" className="text-gray-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white" align="start">
        <Calendar
          mode="single"
          selected={dateObj || undefined}
          onSelect={(d) => {
            if (d) {
              onChange(format(d, 'yyyy-MM-dd'));
              setOpen(false);
            }
          }}
          disabled={(d) => {
            if (minDate && d < parseISO(minDate)) return true;
            if (maxDate && d > parseISO(maxDate)) return true;
            return false;
          }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default DatePickerField;
